import React from 'react';
import { TrophyIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const valueStack: [string, string][] = [['6 Complete Volumes', '$197'], ['5 Exclusive Bonuses', '$91'], ['Lifetime Updates', '$49']];
export function OfferSection() {
  return <section id="offer" className="scroll-mt-12 bg-tr-cream px-5 py-14 md:py-24" data-id="element-138" data-mp="dg87ok6fw44t">
      <Reveal className="mx-auto max-w-container" data-id="element-139" data-mp="icowlglgqmiy">
        <SectionHeading eyebrow="Limited time offer" icon={<TrophyIcon className="h-7 w-7 text-tr-green md:h-8 md:w-8" strokeWidth={1.75} aria-hidden="true" data-id="element-141" data-mp="rdwq7ld1az6p" />} title="Special Launch Offer" data-id="element-140" data-mp="meadre515myy" />
        <div className="relative mx-auto mt-14 w-full max-w-[480px] rounded-card border border-tr-border bg-white p-7 shadow-lifted md:p-9" data-id="element-142" data-mp="2t62swlvzgm8r">
          <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-tr-orange px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-143" data-mp="2y4mhku1yoc4t">
            Best Value
          </span>
          <dl className="space-y-3.5" data-id="element-144" data-mp="sxfi9fku0nsi">
            {valueStack.map(([label, price]) => <div key={label} className="flex items-baseline justify-between gap-4" data-id="element-145" data-mp="owdjezutudr2">
                <dt className="text-sm text-tr-grey" data-id="element-146" data-mp="ouamdvv9bkcu">{label}</dt>
                <dd className="text-sm text-tr-grey line-through" data-id="element-147" data-mp="1llun59a91pq4">{price}</dd>
              </div>)}
          </dl>
          <div className="mt-5 flex items-baseline justify-between border-t border-tr-border pt-5 text-sm font-bold text-tr-navy" data-id="element-148" data-mp="1glgo2gqmlq48">
            <span data-id="element-149" data-mp="17n4qfurcds2a">TOTAL VALUE</span>
            <span data-id="element-150" data-mp="17m3dfkqrmvhx">$337</span>
          </div>
          <div className="mt-6 border-t border-tr-border pt-6 text-center" data-id="element-151" data-mp="16j8woxzd19z">
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-tr-grey/80" data-id="element-152" data-mp="14g9jeaxtvsl">
              Today only
            </p>
            <p className="mt-2 text-6xl font-bold tracking-tight text-tr-navy" data-id="element-153" data-mp="3tthogr91uy69">
              $27
              <span className="ml-1 align-super text-base font-semibold text-tr-grey" data-id="element-154" data-mp="2o853ifk9i5m">
                USD
              </span>
            </p>
          </div>
          <CTAButton href="https://tennis--ready.impultienda.ar/checkout" className="mt-7 w-full py-4" data-id="element-155" data-mp="3kve25sq8pxde" />
          <p className="mt-5 text-center text-[11px] text-tr-grey/80" data-id="element-156" data-mp="3b2zy2tboweo2">
            Secure checkout · Instant access · 30-day guarantee
          </p>
        </div>
      </Reveal>
    </section>;
}